import { createContext, useContext, useState, useCallback } from "react";

const ReservationModalContext = createContext(null);

export function ReservationModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [eventId, setEventId] = useState(null);

  const open = useCallback((opts = {}) => {
    setEventId(opts.eventId || null);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
    setEventId(null);
  }, []);

  return (
    <ReservationModalContext.Provider value={{ isOpen, eventId, open, close }}>
      {children}
    </ReservationModalContext.Provider>
  );
}

export function useReservationModal() {
  const ctx = useContext(ReservationModalContext);
  if (!ctx) throw new Error("useReservationModal must be used inside ReservationModalProvider");
  return ctx;
}
